import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

const Checkbox = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Checkbox" pageType="Forms" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Checkbox Default
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox text-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox text-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input type="checkbox" className="form-checkbox text-success" />
                <span>Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input type="checkbox" className="form-checkbox text-warning" />
                <span>Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input type="checkbox" className="form-checkbox text-danger" />
                <span>Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input type="checkbox" className="text-black form-checkbox" />
                <span>Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox text-muted dark:text-darkmuted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Checkbox Rounded
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="text-black rounded-full form-checkbox"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox text-muted dark:text-darkmuted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Outline
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-black"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox outborder-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Outline Rounded
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-purple"
                  defaultChecked
                />
                <span>Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-info"
                  defaultChecked
                />
                <span>Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-success"
                />
                <span>Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-warning"
                />
                <span>Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-danger"
                />
                <span>Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-black"
                />
                <span>Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded-full form-checkbox outborder-muted"
                />
                <span>Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Checkbox with text color
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-purple"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-purple">Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-info"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-info">Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-success"
                />
                <span className="peer-defaultChecked:text-success">Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-warning"
                />
                <span className="peer-defaultChecked:text-warning">Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-danger"
                />
                <span className="peer-defaultChecked:text-danger">Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="text-black form-checkbox peer"
                />
                <span className="peer-defaultChecked:text-black">Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer text-muted"
                />
                <span className="peer-defaultChecked:text-muted">Muted</span>
              </label>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Outline Checkbox with text color
            </h2>
            <div className="grid grid-cols-1 gap-3">
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-purple"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-purple">Primary</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-info"
                  defaultChecked
                />
                <span className="peer-defaultChecked:text-info">Info</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-success"
                />
                <span className="peer-defaultChecked:text-success">Success</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-warning"
                />
                <span className="peer-defaultChecked:text-warning">Warning</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-danger"
                />
                <span className="peer-defaultChecked:text-danger">Danger</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-black"
                />
                <span className="peer-defaultChecked:text-black">Black</span>
              </label>
              <label className="inline-flex cursor-pointer">
                <input
                  type="checkbox"
                  className="form-checkbox peer outborder-muted"
                />
                <span className="peer-defaultChecked:text-muted">Muted</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Checkbox;
